// extracted by mini-css-extract-plugin
export var adjacentSlide = "_no-9";
export var arrowButtonContainer = "_no-5";
export var arrowButtonIcon = "_no-6";
export var carouselArrowButton = "_no-2";
export var carouselElementContainer = "_no-1";
export var currentSlide = "_no-8";
export var left = "_no-3";
export var otherSlide = "_no-a";
export var productCarouselContainer = "_no-0";
export var right = "_no-4";
export var sliderOverflow = "_no-7";